export enum NavigationEnum {
  DASHBOARDS = '/dashboards',
  MARKETPLACE = '/marketplace',
  MY_ACTIVITIES = '/my-activities',
  DIRECTORY = '/directory',
  BENEFITS = '/benefits',
  EVENTS = '/events',
  SUPPORT_EVENTS = '/support-events',
  SETTINGS = '/settings',
  FAQ = '/faq',
  BOOK_A_ROOM = '/book-a-room',
  BOOK_A_LOUNGE = '/book-a-lounge',
  BOOK_A_ROOF_TOP = '/book-roof-top',
  BOOK_A_FITNESS = '/book-fitness',
  INVITE_GUEST = '/guests',
  MY_COMPANY = '/my-company',
  ALL_GUESTS = '/all-guests',
  CRON_JOBS = '/all-cron-jobs',
  SUBSCRIPTION_MANAGEMENT = '/subscriptions',
}
